import { render, staticRenderFns } from "./TiptapEditor.vue?vue&type=template&id=56a6e872"
import script from "./TiptapEditor.vue?vue&type=script&lang=js"
export * from "./TiptapEditor.vue?vue&type=script&lang=js"
import style0 from "./TiptapEditor.vue?vue&type=style&index=0&id=56a6e872&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports